"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarNumber = exports.CalendarDayTitle = exports.CalendarMonth = exports.CalendarArrow = exports.CalendarDayLine = exports.CalendarHeader = exports.CalendarBody = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../../assets/js/constants");

var _arrowGrey = _interopRequireDefault(require("../../../assets/img/arrow-grey.svg"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CalendarBody = _styledComponents["default"].div.withConfig({
  displayName: "elements__CalendarBody",
  componentId: "sc-15rrt9e-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 328px;\n    max-width: 328px;\n    height: 316px;\n    background: ", ";\n    box-shadow: 0px 4px 10px ", ";\n    border-radius: 4px;\n    align-items: baseline;\n    flex-direction: column;\n    position: absolute;\n    z-index: +1;\n    display: ", ";\n    top: 48px;\n    @media (max-width: 350px) {\n        width: 290px;\n    }\n"])), _constants.COLORS.white, _constants.COLORS.grey, function (props) {
  return props.showCalendar ? 'flex' : 'none';
});

exports.CalendarBody = CalendarBody;

var CalendarHeader = _styledComponents["default"].div.withConfig({
  displayName: "elements__CalendarHeader",
  componentId: "sc-15rrt9e-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    width: 100%;\n    height: 48px;\n    border-bottom: 1px solid ", ";\n    justify-content: space-between;\n    align-items: center;\n"])), _constants.COLORS.grey);

exports.CalendarHeader = CalendarHeader;

var CalendarDayLine = _styledComponents["default"].div.withConfig({
  displayName: "elements__CalendarDayLine",
  componentId: "sc-15rrt9e-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    width: 100%;\n    justify-content: space-around;\n    margin-bottom: 2px;\n"])));

exports.CalendarDayLine = CalendarDayLine;

var CalendarArrow = _styledComponents["default"].div.withConfig({
  displayName: "elements__CalendarArrow",
  componentId: "sc-15rrt9e-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    width: 35px;\n    height: 48px;\n    cursor: pointer;\n    &::before {\n    background: url(", ") center center no-repeat; \n    position: absolute;\n    content: ' ';\n    width: 12px;\n    height: 8px;\n    transform: rotate(90deg);\n    margin: 18px 0 0 25px;\n  }\n"])), _arrowGrey["default"]);

exports.CalendarArrow = CalendarArrow;

var CalendarMonth = _styledComponents["default"].div.withConfig({
  displayName: "elements__CalendarMonth",
  componentId: "sc-15rrt9e-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: flex;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n    color: ", ";\n"])), _constants.COLORS.black);

exports.CalendarMonth = CalendarMonth;

var CalendarDayTitle = _styledComponents["default"].div.withConfig({
  displayName: "elements__CalendarDayTitle",
  componentId: "sc-15rrt9e-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: flex;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n    color: ", ";\n    height: 36px;\n    width: 36px;\n    justify-content: center;\n    align-items: center;\n"])), _constants.COLORS.darkGrey);

exports.CalendarDayTitle = CalendarDayTitle;

var CalendarNumber = _styledComponents["default"].div.withConfig({
  displayName: "elements__CalendarNumber",
  componentId: "sc-15rrt9e-6"
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: flex;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n    color: ", ";\n    background: ", ";\n    border: ", " solid ", ";\n    border-radius: 50%;\n    height: 36px;\n    width: 36px;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    &:hover {\n         background: ", ";\n    }\n"])), function (props) {
  return props.isDisabled ? _constants.COLORS.grey : _constants.COLORS.black;
}, function (props) {
  return props.isSelected ? "".concat(_constants.COLORS.yellow, " !important") : _constants.COLORS.white;
}, function (props) {
  return props.isNow ? '1px' : '0';
}, _constants.COLORS.grey, _constants.COLORS.outlineGrey);

exports.CalendarNumber = CalendarNumber;